import { additionalHeight, findClosestParentWithOffsetTop } from "./modules/animation.js";

(function () {
  const fixedClassName = FIXEDNAV;
  const fixedElements = document.querySelectorAll(fixedClassName);
  const navbar = document.querySelector(NAVBAR);
  const navbarHeight = navbar ? navbar.clientHeight : 0;

  fixedElements.forEach((element) => {
    let parentOffsetTop = findClosestParentWithOffsetTop(element);
    let navPosition = additionalHeight(false, fixedClassName);

    // Préserver la hauteur de l'élément sur le parent pour éviter un saut dans la page
    const adjustParentPosition = () => {
      element.parentElement.style.minHeight = `${element.offsetHeight}px`;
      parentOffsetTop = findClosestParentWithOffsetTop(element);
    };

    document.addEventListener("DOMContentLoaded", () => {
      adjustParentPosition();
      handleStickyFixed();
    });

    function handleStickyFixed() {
      const initialTop = parentOffsetTop - navbarHeight;

      if (window.scrollY > initialTop) {
        element.classList.add("is-active", "ux-fixed");
        element.style.top = `${navPosition}px`;
      } else {
        element.classList.remove("is-active", "ux-fixed");
      }
    }

    window.addEventListener("scroll", () => {
      element.style.top = `${navPosition}px`;
      handleStickyFixed();
    });

    window.addEventListener("resize", () => {
      adjustParentPosition();
      element.style.top = `${navPosition}px`;
      handleStickyFixed();
    });
  });
})();
